module.exports = __webpack_public_path__ + "static/media/11.6ab56e13.jpg";